import { render, staticRenderFns } from "./all-routes.vue?vue&type=template&id=a16382a4&scoped=true"
import script from "./all-routes.vue?vue&type=script&lang=js"
export * from "./all-routes.vue?vue&type=script&lang=js"
import style0 from "./all-routes.vue?vue&type=style&index=0&id=a16382a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a16382a4",
  null
  
)

export default component.exports